module.exports = __webpack_public_path__ + "img/1540084022.98e7dd5f.jpg";